import React from "react";
import { withTranslation } from "react-i18next";
import HardwareIndexTab from "./tabs/hardwareIndexTab/HardwareIndexTab";
import RemoteAttestationTab from "./tabs/remoteAttestationTab/RemoteAttestationTab";
import ReplacementDevicesTab from "./tabs/replacementDevicesTab/ReplacementDevicesTab";
import IsolationHardwareTab from "./tabs/isolationHardwareTab/IsolationHardwareTab";
import CamplaCoreService from "../../services/CamplaCoreService";

import "./Hardware.css";
import {Col, Tab, Tabs, Container, Row} from "react-bootstrap";
import camplaCoreService from "../../services/CamplaCoreService";

class Hardware extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      remoteAttestation: false,
      dialogApiError: "",
      apiError: ""
    };
  }

  async componentDidMount() {
      const user = camplaCoreService.getAuthenticatedUser();
      if (user !== null
          && typeof user["configuration"] !== "undefined"
          && typeof user["configuration"]["services"] !== "undefined"
          && typeof user["configuration"]["services"]["camplaSentinel"] !== "undefined"
          && typeof user["configuration"]["services"]["camplaSentinel"]["enableRemoteAttestation"] !== "undefined") {
        this.setState({
          remoteAttestation: user["configuration"]["services"]["camplaSentinel"]["enableRemoteAttestation"]
        });
      }
  }


  render() {
    const { t } = this.props;


    return (
        <div>
          <Container className="mt-3">
            <Row>
              <Col>
                <Tabs
                    defaultActiveKey="IsolationHardware"
                    id="uncontrolled-tab-example"
                    className="mb-3"
                >
                  <Tab eventKey="IsolationHardware" title={t('Hardware.Tabs.IsolationHardware.Title')}>
                    <IsolationHardwareTab />
                  </Tab>
                  <Tab eventKey="Index" title={t('Hardware.Tabs.Index.Title')} >
                    <HardwareIndexTab />
                  </Tab>
                  {this.state.remoteAttestation ? (<>
                    <Tab eventKey="ReplacementDevices" title={t('Hardware.Tabs.ReplacementDevices.Title')}>
                      <ReplacementDevicesTab />
                    </Tab>
                    <Tab eventKey="RemoteAttestation" title={t('Hardware.Tabs.RemoteAttestation.Title')}>
                      <RemoteAttestationTab />
                    </Tab>
                  </>) : ""}
                </Tabs>
              </Col>
            </Row>
          </Container>
        </div>
    );
  }
}

export default withTranslation()(Hardware);
